import { BiPurchaseTagAlt } from 'react-icons/bi'
import { MdOutlineInventory2, MdOutlineViewAgenda } from 'react-icons/md'
import { MenuItem } from '../types'

const purchasesMenu: MenuItem[] = [
  {
    icon: BiPurchaseTagAlt,
    name: 'Daily',
    path: '/purchases?tab=daily',
    code: 'purchases',
  },
  {
    icon: MdOutlineInventory2,
    name: 'Occasional',
    path: '/purchases?tab=big',
    code: 'purchases',
  },
  {
    icon: MdOutlineViewAgenda,
    name: 'Comparison',
    path: '/purchases?tab=products',
    code: 'purchases',
  },
]

export default purchasesMenu
